import { render, staticRenderFns } from "./TypographyTables.vue?vue&type=template&id=4ecd9d33"
import script from "./TypographyTables.vue?vue&type=script&lang=js"
export * from "./TypographyTables.vue?vue&type=script&lang=js"
import style0 from "./TypographyTables.vue?vue&type=style&index=0&id=4ecd9d33&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports